import { render, staticRenderFns } from "./TemplateCard.vue?vue&type=template&id=2b7ed370&scoped=true"
import script from "./TemplateCard.vue?vue&type=script&lang=js"
export * from "./TemplateCard.vue?vue&type=script&lang=js"
import style0 from "./TemplateCard.vue?vue&type=style&index=0&id=2b7ed370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ed370",
  null
  
)

export default component.exports